import {
  Edge,
  Relationship,
  Vertex,
  VertexEntity,
} from '@jupiterone/jupiter-web-toolkit';

export type GraphEntity = VertexEntity;
export type GraphVertex = Vertex;
export type GraphEdge = Edge;
export type GraphRelationship = Relationship;

export interface GraphData {
  vertices: GraphVertex[];
  edges: GraphEdge[];
}

export interface InspectEdge extends GraphEdge {
  toEntity: GraphEntity;
  fromEntity: GraphEntity;
}

export interface VisNode {
  id: string;
  iconPath: string;
  image: string;
  label: string;
  shape: string;
  size: number;
  opacity?: number;
}

export interface VisEdge {
  id: string;
  from: string;
  to: string;
  label: string;
  font?: { size: number };
  opacity?: number;
  color?: string;
}

export interface NodePositionMap {
  [nodeID: string]: number[];
}

export interface GraphFilters {
  hiddenAccounts: string[];
  hiddenTypes: string[];
  hiddenNodes: string[];
  properties: { [propertyname: string]: any };
  unpackedPacks: string[];
}

export interface J1ToGraphConverterProps {
  selectedNodeId: string | null;
  selectedEdgeId: string | null;
  unrelatedNodeIds?: string[];
}

export interface SelectedNode {
  id: string | null;
  position: [number, number];
}

export type GraphViewMode = 'max' | 'embed';

// These are used as keys for saving position data, do not change the string values
export enum GraphViewType {
  mesh = 'mesh',
  tree = 'tree',
  tree_horizontal = 'tree_horizontal',
}

interface DataSetUpdate {
  id: string;
  fixed?: boolean | { x?: boolean; y?: boolean };
  x?: number;
  y?: number;
}
export interface VisDataSet {
  update: (update: DataSetUpdate | DataSetUpdate[]) => void;
  get: (id: string) => VisNode;
  getIds: () => string[];
}
